/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicableFreeNightCredit
 */
export interface ApplicableFreeNightCredit {
    /**
     * 
     * @type {string}
     * @memberof ApplicableFreeNightCredit
     */
    creditType: ApplicableFreeNightCreditCreditTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ApplicableFreeNightCredit
     */
    remainingCount: number;
    /**
     * 
     * @type {Date}
     * @memberof ApplicableFreeNightCredit
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicableFreeNightCredit
     */
    programName: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicableFreeNightCredit
     */
    pointsCap?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicableFreeNightCredit
     */
    categoryCap?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicableFreeNightCredit
     */
    topUpAllowed: boolean;
}


/**
 * @export
 */
export const ApplicableFreeNightCreditCreditTypeEnum = {
    MarriottFreeNight: 'marriott_free_night',
    HiltonFreeNight: 'hilton_free_night',
    HyattFreeNight: 'hyatt_free_night',
    IhgFreeNight: 'ihg_free_night',
    WyndhamFreeNight: 'wyndham_free_night'
} as const;
export type ApplicableFreeNightCreditCreditTypeEnum = typeof ApplicableFreeNightCreditCreditTypeEnum[keyof typeof ApplicableFreeNightCreditCreditTypeEnum];


/**
 * Check if a given object implements the ApplicableFreeNightCredit interface.
 */
export function instanceOfApplicableFreeNightCredit(value: object): value is ApplicableFreeNightCredit {
    if (!('creditType' in value) || value['creditType'] === undefined) return false;
    if (!('remainingCount' in value) || value['remainingCount'] === undefined) return false;
    if (!('programName' in value) || value['programName'] === undefined) return false;
    if (!('topUpAllowed' in value) || value['topUpAllowed'] === undefined) return false;
    return true;
}

export function ApplicableFreeNightCreditFromJSON(json: any): ApplicableFreeNightCredit {
    return ApplicableFreeNightCreditFromJSONTyped(json, false);
}

export function ApplicableFreeNightCreditFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicableFreeNightCredit {
    if (json == null) {
        return json;
    }
    return {
        
        'creditType': json['credit_type'],
        'remainingCount': json['remaining_count'],
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'programName': json['program_name'],
        'pointsCap': json['points_cap'] == null ? undefined : json['points_cap'],
        'categoryCap': json['category_cap'] == null ? undefined : json['category_cap'],
        'topUpAllowed': json['top_up_allowed'],
    };
}

export function ApplicableFreeNightCreditToJSON(json: any): ApplicableFreeNightCredit {
    return ApplicableFreeNightCreditToJSONTyped(json, false);
}

export function ApplicableFreeNightCreditToJSONTyped(value?: ApplicableFreeNightCredit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credit_type': value['creditType'],
        'remaining_count': value['remainingCount'],
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'program_name': value['programName'],
        'points_cap': value['pointsCap'],
        'category_cap': value['categoryCap'],
        'top_up_allowed': value['topUpAllowed'],
    };
}

